define('lq/events/actions/login',[
    'jquery',
    'lq',
    'lq/storage',
    'lq/events/actions/eventAction'
], function ($, lq, storage, EventAction) {
    'use strict';
    
    function Login(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Login, EventAction);

    Login.typeName = 'Login';

    Login.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    var loginCallback = function (self, result, returnUrl, continuation, showBody) {
        if (result.status === 'Success') {
            if (result.authCookie && storage.localStorageIsAvailable()) {
                localStorage.setItem('licquidAuthCookie', result.authCookie);
                localStorage.setItem('licquidAuthCommandId', result.authCommandId);
            }

            returnUrl = returnUrl || lq.getTenantUrl('');

            if (self.eventIsEnabled('userLoggedIn'))
                self.piping.dispatcher.refreshCsrfToken(function () {
                    self.triggerEvent('userLoggedIn', continuation, returnUrl);
                });
            else
                window.location = returnUrl;
        }
        else {
            if (showBody) $('body').show();

            if (result.status === 'LoginFromLocalStorageFailed')
                return;
            else if (result.status === 'InvalidCaptcha')
                self.handleError('invalidCaptcha', 'The captcha is incorrect.', continuation);
            else if (result.status === 'InvalidCredentials')
                self.handleError('invalidCredentials', 'The username or password provided is incorrect.', continuation);
            else if (result.status === 'AccountLocked')
                self.handleError('accountLocked', 'Your account has been locked out because of too many invalid login attempts.', continuation);
            else
                alert('Unable to login.');
        }
    }

    Login.prototype.getUsername = function() {
        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.usernameField)
            .getValue();
    };

    Login.prototype.getPassword = function() {
        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.passwordField)
            .getValue();
    };

    Login.prototype.getCaptcha = function () {
        if (!this.eventData.captchaField) return null;

        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);

        if (!captchaDrop.data.captchaInputField) return null;

        return this.piping.dropFactory
            .findDropByName(captchaDrop.data.captchaInputField)
            .getValue();
    };

    Login.prototype.execute = function(continuation, eventActionResponse) {
        var username = this.getUsername();
        var password = this.getPassword();
        var captcha = this.getCaptcha();
        var returnUrl = this.piping.queryString.getValueOf('ReturnUrl');

        //deliberately not calling continuation(), because it makes no sense to continue event execution after a login/redirect
        var self = this;
        this.piping.dispatcher.dispatch(
            'LicquidAction/LoginCommand', {
                actionId: this.piping.actionId,
                commandId: this.eventData.command,
                captcha: captcha,
                appId: this.piping.queryString.getValueOf('AppId'),
                parameters: {
                    username: username,
                    password: password
                }
            }, function (result) {
                loginCallback(self, result, returnUrl, continuation, false);
            });
    };

    Login.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    // todo get rid of this
    Login.beforePageRender = function (eventing) {
        if (storage.localStorageIsAvailable()) {
            var authCookie = localStorage.getItem('licquidAuthCookie');
            var authCommandId = localStorage.getItem('licquidAuthCommandId');
            if (authCookie && authCommandId) {
                var returnUrl = eventing.piping.queryString.getValueOf('ReturnUrl');
                var continuation = function () { };

                _.each(eventing.events.handlers, function (event) {
                    _.each(event.actions, function (eventAction) {
                        if (eventAction.command === authCommandId) {
                            var self = new Login(eventAction);
                            self.piping = eventing.piping;

                            $('body').hide();

                            var loaded = false;
                            var delayedCallback = null;

                            // in some cases this is needed to make the 'userLoggedIn'
                            // event of the Login command work
                            eventing.onPageLoad(function() {
                                if (delayedCallback)
                                    delayedCallback();
                                else
                                    loaded = true;
                            });

                            eventing.piping.dispatcher.dispatch(
                                'LicquidAction/LoginFromLocalStorage', {
                                    commandId: authCommandId,
                                    authCookie: authCookie,
                                    appId: eventing.piping.queryString.getValueOf('AppId')
                                }, function (result) {
                                    if (loaded) {
                                        loginCallback(self, result, returnUrl, continuation, true);
                                    } else {
                                        delayedCallback = function() {
                                            loginCallback(self, result, returnUrl, continuation, true);
                                        };
                                    }
                                });
                        }
                    });
                });
            }
        }
    }
        
    return Login;
});
